const Raptor = Mach.requireModule('Raptor');
const SLRaptor = Mach.requireModule('SLRaptor');

const defaultTags = {
  osName: Mach.env.osName ?? '',
  osVersion: Mach.env.osVersion ?? '',
  appVersion: Mach.env.version ?? '',
  platform: Mach.env.isAndroid ? 'Android' : 'iOS',
  env: Mach.env.isDebug ? 'Test' : 'Prod',
  slEnv: Mach.env.isDebug ? 'Test' : 'Prod',
  slAppVer: Mach.env.version ?? '',
  slPlatform: Mach.env.isAndroid ? 'Android' : 'iOS',
  bundleVersion: Mach.env.bundleVersion ?? '',
  bundleName: Mach.env.bundleName ?? '',
};

/**
 * 检查Value类型是否为字符串并转换
 * @param obj
 * @returns
 */
function checkAndConvertToString(obj) {
  if (Array.isArray(obj) || typeof obj !== 'object') {
    return obj;
  }
  const convertObj = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'string') {
        convertObj[key] = obj[key];
      } else if (typeof obj[key] === 'number') {
        convertObj[key] = String(obj[key]);
      }
    }
  }
  return convertObj;
}

/**
 * 上报Report监控指标
 * @param params
 * @param tags
 */
function reportMetrics(params, tags, sampleRate?: number) {
  const tagsObj = { ...tags, ...defaultTags };
  // 校验tag数据是否为字符串
  const tagParams = checkAndConvertToString(tagsObj);
  Raptor?.reportMetrics?.(params, tagParams, (sampleRate || 1.0));
}

export function reportRaptorMetrics(params: {[key: string]: number;}, tags: {[key: string]: string;}, sampleRate?: number) {
  if (SLRaptor) {
    // 校验tag数据是否为字符串
    const tagsObj = { ...tags, ...defaultTags };
    const tagParams = checkAndConvertToString(tagsObj);
    SLRaptor?.reportMetrics?.(params, tagParams, (sampleRate || 1.0));
  } else {
    reportMetrics(params, tags, sampleRate);
  }
}
